import React from 'react';
export function ExpressiveRewiring() {
  return <div className="w-full my-12" data-id="element-68">
      <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6 text-center" data-id="element-69">
        So… How do you show your body it's finally safe to come back online?
      </h2>
      <p className="text-lg text-gray-700 mb-6" data-id="element-70">
        Not through pressure. Not by pushing for a breakthrough. And definitely
        not by forcing emotion to show up before it's ready.
      </p>
      <div className="bg-white p-6 rounded-lg shadow-md mb-8 border border-gray-200" data-id="element-71">
        <div className="flex items-center mb-2" data-id="element-72">
          <div className="w-12 h-12 rounded-full bg-gray-200 mr-3 flex items-center justify-center text-lg font-bold" data-id="element-73">
            T
          </div>
          <div data-id="element-74">
            <h4 className="font-semibold" data-id="element-75">Tanya W., 50</h4>
            <div className="flex items-center text-gray-500 text-sm" data-id="element-76">
              <span className="mx-2" data-id="element-77">•</span>
              <span data-id="element-78">Verified client</span>
            </div>
          </div>
        </div>
        <div className="flex mb-2" data-id="element-79">
          {[1, 2, 3, 4, 5].map(star => <svg key={star} className="w-5 h-5 text-green-500 fill-current" viewBox="0 0 20 20" data-id="element-80">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118l-2.8-2.034c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-81" />
            </svg>)}
        </div>
        <h3 className="font-bold text-lg mb-2" data-id="element-82">
          "It's hard to explain, but something changed after Week 2. My voice
          came back. Literally. I caught myself humming in the kitchen. That
          hasn't happened in years."
        </h3>
      </div>
      <div className="bg-white p-6 rounded-lg shadow-md mb-8 border border-gray-200" data-id="element-83">
        <div className="flex items-center mb-2" data-id="element-84">
          <div className="w-12 h-12 rounded-full bg-gray-200 mr-3 flex items-center justify-center text-lg font-bold" data-id="element-85">
            J
          </div>
          <div data-id="element-86">
            <h4 className="font-semibold" data-id="element-87">Jasmine K., 46</h4>
            <div className="flex items-center text-gray-500 text-sm" data-id="element-88">
              <span className="mx-2" data-id="element-89">•</span>
              <span data-id="element-90">Verified client</span>
            </div>
          </div>
        </div>
        <div className="flex mb-2" data-id="element-91">
          {[1, 2, 3, 4, 5].map(star => <svg key={star} className="w-5 h-5 text-green-500 fill-current" viewBox="0 0 20 20" data-id="element-92">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118l-2.8-2.034c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-93" />
            </svg>)}
        </div>
        <h3 className="font-bold text-lg mb-2" data-id="element-94">
          "This is the first thing I didn't quit halfway through. It met me
          exactly where I was: disconnected, scared, and tired of pushing."
        </h3>
      </div>
      <p className="text-xl text-gray-800 font-bold text-center mb-8" data-id="element-95">
        Instead, a process called Expressive Rewiring, a gentle, body-first
        method that uses sound, movement, and symbolic creativity to help thaw
        emotional shutdown at its source:
      </p>
      <div className="space-y-6 mb-8" data-id="element-96">
        <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-97">
          <p className="font-bold text-purple-800 mb-2" data-id="element-98">
            🌀 It doesn't rely on words
          </p>
          <p className="text-gray-700" data-id="element-99">
            You don't need to explain your trauma or even understand it. Through
            drawing, sound, and body-led motion, your nervous system starts to
            speak its own language—safely and without pressure.
          </p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-100">
          <p className="font-bold text-teal-800 mb-2" data-id="element-101">
            🎨 It taps into the brain regions trauma shuts down
          </p>
          <p className="text-gray-700" data-id="element-102">
            Using sensory expression, this method reactivates the prefrontal
            cortex (for regulation and future-thinking), calms the amygdala
            (your fear center), and stimulates the vagus nerve (your
            calm-connection switch).
          </p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-103">
          <p className="font-bold text-purple-800 mb-2" data-id="element-104">
            🌱 It invites—not forces—emotion to return
          </p>
          <p className="text-gray-700" data-id="element-105">
            By exploring symbolic sound, color, texture, and rhythm, you're not
            digging for feelings—you're giving them a soft place to emerge on
            their own.
          </p>
        </div>
      </div>
      <div className="space-y-6 mb-8" data-id="element-106">
        <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200" data-id="element-107">
          <div className="flex items-center mb-2" data-id="element-108">
            <div className="w-12 h-12 rounded-full bg-gray-200 mr-3 flex items-center justify-center text-lg font-bold" data-id="element-109">
              M
            </div>
            <div data-id="element-110">
              <h4 className="font-semibold" data-id="element-111">Marissa T., 54</h4>
              <div className="flex items-center text-gray-500 text-sm" data-id="element-112">
                <span className="mx-2" data-id="element-113">•</span>
                <span data-id="element-114">Verified client</span>
              </div>
            </div>
          </div>
          <div className="flex mb-2" data-id="element-115">
            {[1, 2, 3, 4, 5].map(star => <svg key={star} className="w-5 h-5 text-green-500 fill-current" viewBox="0 0 20 20" data-id="element-116">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118l-2.8-2.034c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-117" />
              </svg>)}
          </div>
          <h3 className="font-bold text-lg mb-2" data-id="element-118">
            "I wasn't even sure I had emotions anymore. This program didn't
            force them out—it gently invited them back. I cried for the first
            time in 8 years."
          </h3>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200" data-id="element-119">
          <div className="flex items-center mb-2" data-id="element-120">
            <div className="w-12 h-12 rounded-full bg-gray-200 mr-3 flex items-center justify-center text-lg font-bold" data-id="element-121">
              D
            </div>
            <div data-id="element-122">
              <h4 className="font-semibold" data-id="element-123">Denise R., 48</h4>
              <div className="flex items-center text-gray-500 text-sm" data-id="element-124">
                <span className="mx-2" data-id="element-125">•</span>
                <span data-id="element-126">Verified client</span>
              </div>
            </div>
          </div>
          <div className="flex mb-2" data-id="element-127">
            {[1, 2, 3, 4, 5].map(star => <svg key={star} className="w-5 h-5 text-green-500 fill-current" viewBox="0 0 20 20" data-id="element-128">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118l-2.8-2.034c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-129" />
              </svg>)}
          </div>
          <h3 className="font-bold text-lg mb-2" data-id="element-130">
            "I've done somatic therapy. I've done EMDR. But nothing reached the
            place this touched—the frozen part of me that stopped trusting I
            could feel safe in my own body."
          </h3>
        </div>
      </div>
      <div className="text-lg text-gray-700 space-y-4" data-id="element-131">
        <p data-id="element-132">
          This isn't art therapy. It's not performance. And it's not about
          creating something beautiful.
        </p>
        <p data-id="element-133">
          It's about small, doable creative actions—like tapping a bowl,
          scribbling a shape, humming a sound, or moving your hand in
          rhythm—that slowly begin to reconnect the parts of you that shut down
          to survive.
        </p>
      </div>
      <h2 className="text-2xl md:text-3xl font-bold text-gray-800 my-6 text-center" data-id="element-134">
        You're not trying to "break through" your numbness. You're gently
        melting it.
      </h2>
      <div className="text-lg text-gray-700 space-y-4" data-id="element-135">
        <p data-id="element-136">One mark. One sound. One sensation at a time.</p>
        <p className="font-bold" data-id="element-137">
          And over time, your body starts to believe that it's safe to feel
          again.
        </p>
        <p data-id="element-138">
          That's the quiet magic of Expressive Rewiring. And it's exactly what
          we'll guide you through—step by step—inside this 4-week journey.
        </p>
      </div>
    </div>;
}